import { useState, useEffect, useCallback } from "react";

type DrawerSide = "left" | "right" | null;

export const useDrawer = () => {
  const [openDrawer, setOpenDrawer] = useState<DrawerSide>(null);

  const openLeft = useCallback(() => setOpenDrawer("left"), []);
  const openRight = useCallback(() => setOpenDrawer("right"), []);
  const closeDrawer = useCallback(() => setOpenDrawer(null), []);

  useEffect(() => {
    if (!openDrawer) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") closeDrawer();
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [openDrawer, closeDrawer]);

  return {
    openDrawer,
    isLeftOpen: openDrawer === "left",
    isRightOpen: openDrawer === "right",
    openLeft,
    openRight,
    closeDrawer,
  };
};
